import { TableCell, TableHead, TableRow } from '@mui/material';

type HeadCell = {
  disablePadding: boolean;
  id: string;
  label: string;
  numeric: boolean;
};

const headCells: readonly HeadCell[] = [
  {
    id: 'title',
    numeric: false,
    disablePadding: false,
    label: 'Ad title',
  },
  {
    id: 'preview',
    numeric: false,
    disablePadding: false,
    label: 'Preview',
  },
  {
    id: 'displays',
    numeric: false,
    disablePadding: false,
    label: 'Displays',
  },
  {
    id: 'views',
    numeric: false,
    disablePadding: false,
    label: 'Views',
  },
  {
    id: 'status',
    numeric: false,
    disablePadding: false,
    label: 'Status',
  },
  {
    id: 'publishedAt',
    numeric: false,
    disablePadding: false,
    label: 'Published at',
  },
];

export const EnhancedTableHead = () => {
  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
          >
            {headCell.label}
          </TableCell>
        ))}
        <TableCell>Actions</TableCell>
      </TableRow>
    </TableHead>
  );
};
